import React from 'react'
import styled from 'styled-components'
import Channel from './channel'
import { getFilteredChannels } from 'src/modules/utils/channels'
import { spacing } from 'src/constants/marketing-ds'

const ChannelList = ({ channels, activeCategory }) => {
  const hasChannels = channels.length ? true : false
  const showAllChannels = activeCategory === 'all'
  const channelList = showAllChannels ? channels : getFilteredChannels(channels, activeCategory)

  if (!hasChannels) return null

  return (
    <SectionList>
      {channelList.map((channel, index) => (
        <Channel key={channel.id + '_' + index} channel={channel} />
      ))}
    </SectionList>
  )
}

export default ChannelList

const SectionList = styled.ul`
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto;
  padding: 0;
  gap: ${spacing.md} ${spacing.xs};
  max-width: 1050px;

  .logosoup-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: ${spacing.xs};
    width: 100%;
    margin-bottom: ${spacing.md};
  }
`
